export enum PropertySingleViewSection {
  MAIN_SECTION = 'main-section',
  AVAILABLE_PROPERTIES_SECTION = 'available-properties-section',
  FACILITIES_SERVICES_SECTION = 'facilities-and-services',
  MAP_SECTION = 'map-section',
  VIRTUAL_TOUR_SECTION = 'virtual-tour-section',
  AREA_GUIDE_SECTION = 'area-guide-section',
  SIMILAR_PROPERTIES_SECTION = 'similar-properties-section',
}
